import { FC } from 'react';
import { EnumDropdownProps } from 'src/models/FieldProps.interface';
import { GRNStatus } from 'src/models/enums/GRNStatus.enum';
import {
  ContainerBox,
  LabelTypography,
  StyledFormControl,
  StyledFormHelperText,
  ErrorIcon,
} from './GRNStatusPicker.styles';
import FormikSelectField, { Option } from './FormikSelectField';

const grnStatusOptions: Option[] = [
  { value: GRNStatus.NEW, label: 'New' },
  { value: GRNStatus.PENDING, label: 'Pending Approval' },
  { value: GRNStatus.APPROVED, label: 'Approved' },
  { value: GRNStatus.REJECTED, label: 'Rejected' },
  { value: GRNStatus.PAYMENT_PROGRESS, label: 'Payment Progress' },
  { value: GRNStatus.PAID, label: 'Paid' },
];

const GRNStatusPicker: FC<EnumDropdownProps> = ({
  id,
  label,
  showLabel = true,
  formikProps,
  errorState = false,
  height = '40px',
  width = '450px',
  textColor = 'var(--primary-navy)',
  fontSize = '16px',
  fontWeight = '400',
  borderColor = 'var(--border)',
  customMessage,
}) => {
  const hasError =
    (formikProps.touched[id] && Boolean(formikProps.errors[id])) || errorState;

  return (
    <ContainerBox>
      {showLabel && (
        <LabelTypography
          fontWeight={fontWeight}
          fontSize={fontSize}
          color={textColor}
        >
          {label}
        </LabelTypography>
      )}
      <StyledFormControl fullWidth error={hasError}>
        <FormikSelectField
          label={label}
          height={height}
          width={width}
          borderColor={borderColor}
          fontSize={fontSize}
          fontWeight={fontWeight}
          id={id}
          formikProps={formikProps}
          options={grnStatusOptions}
          showLabel={false}
        />
        {formikProps.touched[id] && formikProps.errors[id] && (
          <StyledFormHelperText>
            <ErrorIcon component="i" className="bx bxs-error-circle" />
            {formikProps.errors[id]}
          </StyledFormHelperText>
        )}
      </StyledFormControl>
    </ContainerBox>
  );
};

export default GRNStatusPicker;
